import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { userSlice } from './reducer/userSlice/userSlice';
import { categoriesListSlice } from './reducer/categoriesListSlice/categories';
import { offerZoneSlice } from "./reducer/offerZoneSlice/offerZoneSlice";
import {
  addressReducer, addressSliceName,
  listingReducer, listingSliceName,
  planReducer, planSliceName,
  loginReducer, loginSliceName,
  userReducer, userSliceName
} from './slices';

const store = configureStore({
  reducer: {
    [loginSliceName]: loginReducer,
    [userSlice.name]: userSlice.reducer,
    [categoriesListSlice.name]: categoriesListSlice.reducer,
    [offerZoneSlice.name]: offerZoneSlice.reducer,
    [addressSliceName]: addressReducer,
    [planSliceName]: planReducer,
    [listingSliceName]: listingReducer,
    [userSliceName]: userReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat()
});

setupListeners(store.dispatch);

export { store };